import script from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./InfoPanel.vue?vue&type=style&index=0&id=01cdb198&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cdb198"]])

export default __exports__